export const removeEmptyKeysFromObject = (obj?: { [x: string]: any }) => {
  if (!obj) {
    return {};
  } else {
    Object.keys(obj).forEach((k) => !obj[k] && delete obj[k]);
    return obj;
  }
};
